<template>
  <svg :style="style" :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8.5H4" :stroke="color" stroke-width="1.5" stroke-linecap="round" @mouseover="isHover=true" @mouseout="isHover = false"/>
    <path d="M8 4.5L4 8.5L8 12" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" @mouseover="isHover=true" @mouseout="isHover = false"/>
  </svg>
</template>

<script>
export default {
  name: 'ArrowIcon',
  props: {
    color: {
      type: String,
      default: '#242424'
    },
    size: {
      type: String,
      default: '16'
    },
    isInverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      return {
        transform: `rotate(${this.isInverted ? '180' : '0'}deg)`
      }
    }
  }
}
</script>
